module.exports = __webpack_public_path__ + "img/120.71baeb6a.png";